import * as ko from "knockout";
import {moment} from 'moment';
import {nsRule} from "../nsRule";
import {IRuleMutable} from "../index";
import {KOSubscriptionTracker} from "../../../../../util/KOSubscriptionTracker";
import {convertFromServerString, convertToServerString} from "../../../../../util/datetime";
import {INPUT_DATE_FORMAT, ObjectTypeId} from "../../../../../constants";
import {nsRuleset} from "../../../nsRuleset";
import {nsDynamicVariable} from "../../../../dynamic-variable/nsDynamicVariable";
import {getNextId, isNullOrUndefined, isNullOrUndefinedOrEmptyString} from "../../../../../util/misc";
import InputMode = nsRule.InputMode;
import validateRange = nsRuleset.validateRange;
import validateExpression = nsDynamicVariable.validateExpression;
import getRangeValue = nsRuleset.getRangeValue;
import datetimeHtml from './datetime.html?raw';

export const template = datetimeHtml;

interface IParams {
    objectTypeId: ObjectTypeId
    objectTypeIds: ObjectTypeId[]
    ruleMutable: IRuleMutable
}

export class viewModel {

    private InputMode = InputMode;

    private argument: KnockoutObservable<string>;

    private readonly date: KnockoutObservable<string | null> = ko.observable(null);
    private readonly expression: KnockoutObservable<string | null> = ko.observable(null);
    private readonly range: KnockoutObservable<number | null> = ko.observable(null);

    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly inputMode: KnockoutObservable<InputMode | null> = ko.observable(null);
    private readonly ruleMutable: IRuleMutable
    private readonly objectTypeId: ObjectTypeId
    private readonly objectTypeIds: ObjectTypeId[]

    private readonly radioBtn_name: string = 'radio-button-' + getNextId()

    constructor(params: IParams) {
        this.objectTypeId = params.objectTypeId
        this.objectTypeIds = params.objectTypeIds
        this.ruleMutable = params.ruleMutable;
        this.argument = this.ruleMutable.argument as KnockoutObservable<string>;

        this.initArg()

        this.kosub.subscribe(this.range, () => {
            if (this.inputMode() == InputMode.Range) {
                const val = this.range();
                if (val === null) {
                    return;
                }
                const formatted = val >= 0 ? "+" + val : String(val);
                this.argument(`[NOW${formatted}]`);
            }
        });

        this.kosub.subscribe(this.date, (date: string | null) => {
            if (this.inputMode() == InputMode.DatePicker && date) {
                const val = convertToServerString(moment(date, INPUT_DATE_FORMAT), true);
                if (val) {
                    this.argument(val);
                }
            }
        });

        this.kosub.subscribe(this.expression, (val: string | null) => {
            if (this.inputMode() == InputMode.Text && val !== null) {
                this.argument(val);
            }
        });

        this.kosub.subscribeChanged(this.inputMode, (_new, _old) => {
            switch (_new) {
                case InputMode.Range: {
                    if (isNullOrUndefinedOrEmptyString(this.range())) {
                        this.range(0);
                    }
                    this.range.valueHasMutated?.()
                    break;
                }
                case InputMode.DatePicker: {
                    if (isNullOrUndefinedOrEmptyString(this.date())) {
                        const date = moment().startOf('day')
                        this.date(date.format(INPUT_DATE_FORMAT))
                    }
                    this.date.valueHasMutated?.()
                    break;
                }
                case InputMode.Text: {
                    if (isNullOrUndefined(this.expression())) {
                        this.expression('')
                    }
                    this.expression.valueHasMutated?.()
                    break;
                }
            }
        })

    }

    private initArg() {
        const arg = this.argument()
        if (validateRange(arg)) {
            const val = getRangeValue(arg)
            this.range(val);
            this.inputMode(InputMode.Range)
        } else if (validateExpression(arg)) {
            this.expression(arg)
            this.inputMode(InputMode.Text)
        } else {
            this.date(convertFromServerString(arg).format(INPUT_DATE_FORMAT));
            this.inputMode(InputMode.DatePicker)
        }
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }

}
